<template>
    <div class="start-page" @click="goHome">
      <!-- PC 端图片 -->
      <img src="@/assets/start-pc.jpg" class="bg-img pc-img" />
  
      <!-- 移动端图片 -->
      <img src="@/assets/start-mobile.jpg" class="bg-img mobile-img" />
  
      <!-- 版权 -->
      <div class="copyright">
        Copyright ©湖北省人才发展集团有限公司. All Rights Reserved
      </div>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      goHome() {
        this.$router.push('/home')
      }
    }
  }
  </script>
  
  <style scoped lang="less">
  .start-page {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    background: #fff;
  }
  
  /* 核心：宽高 100% 铺满屏幕，等比缩放，完整显示 */
  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: fill; /* 宽高100%填满屏幕 */
    z-index: 1;
  }
  
  /* PC 显示 */
  .pc-img {
    display: block;
  }
  .mobile-img {
    display: none;
  }
  
  /* 移动端显示 */
  @media (max-width: 992px) {
    .pc-img {
      display: none;
    }
    .mobile-img {
      display: block;
    }
  }
  
  .copyright {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 12px;
    color: #666;
    z-index: 99;
  }
  </style>